import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export default {
  name: 'CategorySeo',
  props: {
    metaTitle: {
      type: String,
      required: true
    },
    metaDescription: {
      type: String,
      required: true
    }
  },
  head: function head() {
    return {
      title: "".concat(this.metaTitle, " | Maisons du Monde"),
      meta: [{
        charset: 'utf-8'
      }, {
        name: 'description',
        content: this.metaDescription
      }]
    };
  },
  render: function render(h) {
    return h(null);
  }
};